export const ADMIN_BUILD_INFO = {
  "buildId": "4198b54c539743c58b4e729c6b60772b63694c30-0.17.0-rc.241",
  "gitSha": "4198b54c539743c58b4e729c6b60772b63694c30",
  "packageVersion": "0.17.0-rc.241"
} as const;
